import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WrapperStandardRequest, WrapperStandardResponse } from '../../common/models/wrapper.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class BaseRepository<T> {


  // public abstract getById(id: number): Observable<T>;
  //public abstract getAll(): Observable<T>;

  constructor(private httpClient: HttpClient) {

  }

  // getAll(id: number): Observable<any> {
  //   return this.httpClient
  //     .get<WrapperStandardResponse<T>>('http://5b8d40db7366ab0014a29bfa.mockapi.io/api/v1/elephants/${id}')
  //     .pipe(map((response: WrapperStandardResponse<T>) => {
  //       return response.ResponseData;
  //     }));
  // }

  // getAllNew() {
  //   return this.httpClient
  //     .post<WrapperStandardResponse<T>>('https://localhost:7293/api/User/GetUserService',WrapperStandardRequest<T>)
  //     .pipe(map((response: WrapperStandardResponse<T>) => {
  //       return response.ResponseData;
  //     }));
  // }
 
  // getAll(userInput: any): Observable<T> {
  //   const inputData: WrapperStandardRequest<T> = new WrapperStandardRequest<T>();
  //   // const inputData: WrapperInputModel<commonView> = new WrapperInputModel<commonView>();
  //   // inputData.data = userInput.Data;
  //   return this.httpClient.post("https://localhost:7293/api/User/GetUserService", inputData,httpOptions) 
  //   .pipe(map((response: any) => {
  //     return response;
  //   }))
     
  // }
  getAll(aUrl: string, aRequestData: any) : Observable<T> {
    const wrapperStandardRequest: WrapperStandardRequest<T> = new WrapperStandardRequest<T>();
    // const inputData: WrapperInputModel<commonView> = new WrapperInputModel<commonView>();
    wrapperStandardRequest.RequestData = aRequestData;
    let obj ={
      "Data": {
          "UserType": "Dr"
      }
  }
    return this.httpClient.post(aUrl, wrapperStandardRequest, httpOptions) 
    .pipe(map((response: any) => {
      return response;
    }))
     
  }
  // public getMenuList(): Observable<any> {
  //   return this.httpClient.get("assets/masterMenu.json");
  // } 

}